<template>
	<v-card class="pa-2">
		{{ data }}
	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import toast from '@/util/toast'

	export default {
		name: 'RefahAuthorizationItem',
		props: {
			data: { type: String, default: '' },
		},
		data() {
			return {

			}
		},
		computed: {

		},
		mounted() {

		},
		methods: {

		}
	}
</script>
<style scoped></style>
